export default __webpack_public_path__ + "4ae9f1bbc1539e486e02b0bb8dcfd83c.png";